// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__ebuC1","selected":"Chip_selected__-ArRK"};